import { Query, FilterGroup } from '@kentik/ui-shared/query/query.types';
import { METRIC_TITLES } from '../testResults/panels/synthUdeMetrics/constants';
import {
  getMetricDefs,
  getSynthHints,
  MetricChartConfig,
  TestConfigLike,
  TimeRange
} from '../testResults/panels/synthUdeMetrics/buildMetricQueries';

function buildAgentFilters(
  testId: string,
  agentId: string,
  targetId: string | undefined,
  targetDimension: string | undefined
): { connector: 'All'; filterGroups: FilterGroup[] } {
  const filters = [
    { filterField: 'test_id', operator: '=', filterValue: testId, rightFilterField: '' },
    { filterField: 'src_agent', operator: '=', filterValue: agentId, rightFilterField: '' }
  ];

  if (targetId && targetDimension) {
    filters.push({ filterField: targetDimension, operator: '=', filterValue: targetId, rightFilterField: '' });
  }

  return {
    connector: 'All',
    filterGroups: [{ connector: 'All', not: false, filters, filterGroups: [] }]
  };
}

/**
 * Builds UDE metric chart configs for a single agent+target pair on the agent results page.
 * No dimensions needed (single series per chart).
 */
export function buildAgentMetricCharts(
  test: TestConfigLike,
  agentId: string | number,
  targetId: string | undefined,
  timeRange: TimeRange
): MetricChartConfig[] {
  const metricDefs = getMetricDefs(test);
  const testId = String(test.id);
  const agentIdStr = String(agentId);

  return metricDefs.map((def) => {
    const query: Query = {
      measurement: def.measurement,
      metrics: [{ name: def.metric }],
      dimensions: [],
      rollups: [{ metric: def.metric, fn: def.rollupFn || 'avg' }],
      filters: {
        dimensions: buildAgentFilters(testId, agentIdStr, targetId ? String(targetId) : undefined, def.targetDimension)
      },
      time: { lookback: 0, start: timeRange.start, end: timeRange.end },
      viz: { type: 'line', limit: 10 },
      limit: 10
    };

    // Align bins to the test frequency; single series, so no cardinality hint (keeps single-pass defaults)
    Object.assign(query, { _synthHints: getSynthHints(test) });

    return {
      key: `${def.measurement}__${def.metric}`,
      title: METRIC_TITLES[def.metric] || def.metric,
      query
    };
  });
}
